const about_url='/api/about/about.detail';
const passwordLogin='/api/digitalDisplayScreen/passwordLogin'
const infoStatistics='/api/digitalDisplayScreen/infoStatistics'
const infoStatisticsRight='/api/digitalDisplayScreen/infoStatisticsRight'
const infoStatisticsLeft='/api/digitalDisplayScreen/infoStatisticsLeft'
const infoStatisticsLeft2='/api/digitalDisplayScreen/infoStatisticsLeft2'
const listAllToTree='/api/digitalDisplayScreen/listAllToTree'
const mapInfoList='/api/digitalDisplayScreen/mapInfoList'
const companyDetails='/api/digitalDisplayScreen/companyDetails'
const rescueStrengthPage='/api/digitalDisplayScreen/rescueStrengthPage'
const rescueStrengthDetails='/api/digitalDisplayScreen/rescueStrengthDetails'
const taskRecordPage='/api/digitalDisplayScreen/taskRecordPage'
const chargingPilePage='/api/digitalDisplayScreen/chargingPilePage'
const chargingPileDetails='/api/digitalDisplayScreen/chargingPileDetails'
const flareUpStatistics='/api/digitalDisplayScreen/flareUpStatistics'
const flareUpCompanyPage='/api/digitalDisplayScreen/flareUpCompanyPage'
const flareUpRecordPage='/api/digitalDisplayScreen/flareUpRecordPage'
const courseTypeStatistics='/api/digitalDisplayScreen/courseTypeStatistics'
const studyRecordRankingPage='/api/digitalDisplayScreen/studyRecordRankingPage'
const fireWarningStatistics='/api/digitalDisplayScreen/fireWarningStatistics'
const fireWarningCompanyPage='/api/digitalDisplayScreen/fireWarningCompanyPage'
const cameraDevicePage='/api/digitalDisplayScreen/cameraDevicePage'
const smartElectricityDevicePage='/api/digitalDisplayScreen/smartElectricityDevicePage'
const fuelGasDetectDevicePage='/api/digitalDisplayScreen/fuelGasDetectDevicePage'
const smokeDetectorDevicePage='/api/digitalDisplayScreen/smokeDetectorDevicePage'
const dutiesStatistics='/api/digitalDisplayScreen/dutiesStatistics'
const dutiesCityList='/api/digitalDisplayScreen/dutiesCityList'
const childDutiesCityList='/api/digitalDisplayScreen/childDutiesCityList'
const dutiesCompanyPage='/api/digitalDisplayScreen/dutiesCompanyPage'
const dutiesCompanyRankingPage='/api/digitalDisplayScreen/dutiesCompanyRankingPage'
const patrolInspectRecordPage='/api/digitalDisplayScreen/patrolInspectRecordPage'
const messageRemindPage='/api/digitalDisplayScreen/messageRemindPage'
const backurl='https://xcx.xfttc.com'
const getUserInfo='/api/digitalDisplayScreen/getUserInfo'
const getFireAlarmStatistics='/api/digitalDisplayScreen/fireAlarmStatistics'
const getFireWarningCompanyMapList='/api/digitalDisplayScreen/fireWarningCompanyMapList'
const getDutiesCityRankingPage='/api/digitalDisplayScreen/dutiesCityRankingPage'
export default {
    about_url,
  passwordLogin,
  infoStatistics,
  infoStatisticsRight,
  infoStatisticsLeft,
  infoStatisticsLeft2,
  listAllToTree,
  mapInfoList,
  companyDetails,
  rescueStrengthPage,
  rescueStrengthDetails,
  taskRecordPage,
  chargingPilePage,
  chargingPileDetails,
  flareUpStatistics,
  flareUpCompanyPage,
  flareUpRecordPage,
  courseTypeStatistics,
  studyRecordRankingPage,
  fireWarningStatistics,
  fireWarningCompanyPage,
  cameraDevicePage,
  smartElectricityDevicePage,
  fuelGasDetectDevicePage,
  smokeDetectorDevicePage,
  dutiesStatistics,
  dutiesCityList,
  childDutiesCityList,
  dutiesCompanyPage,
  dutiesCompanyRankingPage,
  patrolInspectRecordPage,
  messageRemindPage,
  backurl,
  getUserInfo,
  getFireAlarmStatistics,
  getFireWarningCompanyMapList,
  getDutiesCityRankingPage
}
